import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback
} from "react";
import axios from "axios";
import { API } from "../api/auth";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  /*
  =========================
  FETCH USER (FIX useCallback)
  =========================
  */
  const fetchUser = useCallback(async () => {

    const token = localStorage.getItem("token");

    if (!token) {
      setLoading(false);
      return;
    }

    try {

      const res = await axios.get(`${API.BASE_URL}/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setUser(res.data);

    } catch (error) {

      // 🔥 important: ne boucle pas infiniment
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      setUser(null);

    } finally {
      setLoading(false);
    }

  }, []);

  /*
  =========================
  LOGIN
  =========================
  */
  const login = (token, refresh = null, userData = null) => {

    localStorage.setItem("token", token);

    if (refresh) {
      localStorage.setItem("refresh_token", refresh);
    }

    if (userData) {
      setUser(userData);
      setLoading(false);
    } else {
      fetchUser();
    }
  };

  /*
  =========================
  LOGOUT
  =========================
  */
  const logout = () => {

    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");

    setUser(null);

    window.location.href = "/";
  };

  /*
  =========================
  INIT
  =========================
  */
  useEffect(() => {
    fetchUser();
  }, [fetchUser]); // ✅ FIX ESLINT

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};